import axios from "axios";
import { ELEARNING_API_URL } from "../apiConfig";
import ElearningAuthService from "./elearningAuth.service";

const authHeader = () => {
  const user = ElearningAuthService.getCurrentUser();
  return user && user.token ? { Authorization: `Bearer ${user.token}` } : {};
};

const getCompletions = () => {
  return axios.get(ELEARNING_API_URL + "completions", { headers: authHeader() });
};

const getQuiz = () => {
  return axios.get(ELEARNING_API_URL + "quiz", { headers: authHeader() });
};

const saveCompletion = (data) => {
  // Accept object format: { courseKey, score, passed }
  return axios.post(
    ELEARNING_API_URL + "completions",
    data,
    { headers: authHeader() }
  );
};

const submitQuiz = (answers) => {
  return axios.post(
    ELEARNING_API_URL + "quiz/submit",
    { answers },
    { headers: authHeader() }
  );
};

const ElearningService = {
  getCompletions,
  getQuiz,
  saveCompletion,
  submitQuiz
};

export default ElearningService;
